export const ALL_CLOSED_VALUE = '__hs__TICKET_CLOSED';